// extracted by mini-css-extract-plugin
export default {"popper":"popper_popper__oi5Lp","arrow":"popper_arrow__jIIKq"};